<template>
  <div class="policy-container">
    <h1>포인트 충전 서비스 이용 규정</h1>

    <section>
      <h2>1. 포인트 유효기간</h2>
      <p>
        포인트는 결제일로부터
        <strong>3개월</strong>
        간 유효하며, 이후 자동 소멸됩니다.
      </p>
    </section>

    <section>
      <h2>2. 결제 및 환불 규정</h2>
      <ul>
        <li>
          포인트는 결제 후 사용하지 않은 경우,
          <strong>결제일로부터 7일 이내</strong>
          에 환불 요청 시 전액 환불됩니다.
        </li>
        <li>
          회사는 회원이 신용카드 또는 전자화폐 등의 결제수단으로 대금을 지급한
          경우, 환불 시 지체 없이 해당 결제수단 제공사에 청구 정지 또는 결제
          취소를 요청합니다.
        </li>
      </ul>
    </section>

    <section>
      <h2>3. 카드사별 결제 한도 안내</h2>
      <p>
        아래는 카드사별 포인트 충전 결제 한도입니다. 카드사 정책에 따라 제한될
        수 있습니다.
      </p>
      <table>
        <thead>
          <tr>
            <th>카드사</th>
            <th>일 한도</th>
            <th>월 한도</th>
            <th>건당 한도</th>
            <th>일 승인횟수</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>삼성카드</td>
            <td>-</td>
            <td>500,000원</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>신한카드</td>
            <td>50,000원</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>국민카드</td>
            <td>-</td>
            <td>1,000,000원</td>
            <td>-</td>
            <td>4회</td>
          </tr>
          <tr>
            <td>하나카드</td>
            <td>1,000,000원</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>현대카드</td>
            <td>550,000원</td>
            <td>-</td>
            <td>110,000원</td>
            <td>5회</td>
          </tr>
          <tr>
            <td>롯데카드</td>
            <td>500,000원</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>농협카드</td>
            <td>500,000원</td>
            <td>-</td>
            <td>100,000원</td>
            <td>10회</td>
          </tr>
          <tr>
            <td>우리카드</td>
            <td>300,000원</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section>
      <h2>4. 휴대폰 소액결제</h2>
      <ul>
        <li>
          휴대폰 소액결제는
          <strong>당월에 한해 취소가 가능</strong>
          하며, 익월 이후에는 취소가 불가능합니다.
        </li>
        <li>
          익월 이후 환불은
          <strong>통신사 청구요금 수납 확인 후</strong>
          , 결제자 본인 명의의 계좌로 환불됩니다.
        </li>
        <li>결제 수단에 따라 환불 소요 기간 및 절차는 상이할 수 있습니다.</li>
      </ul>
    </section>

    <section>
      <h2>5. 할부거래 및 계좌이체 제한</h2>
      <ul>
        <li>
          신용카드 할부는
          <strong>최대 3개월</strong>
          까지만 지원됩니다.
        </li>
        <li>
          계좌이체는
          <strong>1일 1계좌 기준 최대 50만원</strong>
          까지 가능합니다.
        </li>
      </ul>
    </section>

    <section>
      <h2>6. 포인트 사용처</h2>
      <p>
        충전한 포인트는 본 서비스 내 유료 기능(예: 콘텐츠 열람, 결과 확인 등)에
        사용되며, 현금으로 전환하거나 외부로 송금할 수 없습니다.
      </p>
    </section>
    <p>
      본 포인트 충전 서비스 이용 규정은
      리디아트리(사업자등록번호:437-20-01228)에서 제공하는 '인생의 역점'
      서비스에 적용됩니다.
    </p>

    <div class="button-container">
      <button class="confirm-button" @click="goBack">확인</button>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped>
  .policy-container {
    max-width: 480px;
    margin: 0 auto;
    padding: 2rem;
    font-size: var(--font-size-095);
    line-height: 1.6;
  }

  h1 {
    font-size: var(--font-size-14);
    margin-bottom: 1rem;
  }

  h2 {
    font-size: var(--font-size-11);
    margin-top: 1.5rem;
  }

  ul {
    padding-left: 1.2rem;
    list-style: disc;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0.5rem;
    font-size: var(--font-size-085);
  }

  th,
  td {
    border: 1px solid #ccc;
    padding: 6px 8px;
    text-align: center;
  }

  th {
    background-color: #f5f5f5;
  }

  .button-container {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }

  .confirm-button {
    padding: 0.7rem 1.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
  }

  .confirm-button:hover {
    background-color: #45a049;
  }
</style>
